import * as React from 'react'

import {Alert, Button, Form} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import KixGbcMemberLayout from "../../layouts/KixGbcMemberLayout/KixGbcMemberLayout";
import commonStyles from '../../../src/styles/common.scss';
import {Link} from "react-router-dom";
import {KixGbcInformationStore} from "../../store/InformationStore";
import {loginUserStore} from "../../store/Login/LoginUserStore";
import appStyles from "../../assets/css/app.scss";
import {safeRedirect} from "../../../src/utils/redirect/safeRedirect";
import use_fast_lane from "../../assets/viewImg/top_kix_fastlane.png";
import use_lounge from "../../assets/viewImg/top_kix_lounge.png";
import use_lounge_second from "../../assets/viewImg/top_itm_kobe_lounge.png";
import mypage_banner from "../../assets/viewImg/mypage_banner.jpg";
import how_to_use_banner from "../../assets/viewImg/how_to_use_banner.jpg";
import koukuu_service_banner from "../../assets/viewImg/koukuu_service_banner.jpg";
import tokutenn_banner from "../../assets/viewImg/tokutenn_banner.jpg";
import btn_vip from "../../assets/viewImg/btn_vip.jpg";
import {FastlaneService} from "../../service/FastlaneService";
import moment from "moment";
import {timeStore} from "../../store/TimeStore";

@observer
class Member extends ViewBaseComponent<{} & FormComponentProps, {}> {
  informationStore: KixGbcInformationStore | undefined;
  formUtils = this.props.form;
  fastLaneService = new FastlaneService(this.formUtils, 1);
  loungeService = new FastlaneService(this.formUtils, 2);
  loungeSecondService = new FastlaneService(this.formUtils, 2, 1)

  componentWillMount() {
    this.informationStore = new KixGbcInformationStore();

    loginUserStore.getLoginUser().then(() => {
      // kix-gbc用APIを使用（ユーザーに紐づいたお知らせのみ取得）
      this.informationStore!.getList();
    });
  }

  componentWillUnmount() {
    this.informationStore = void 0
  }

  render() {
    return (
      <KixGbcMemberLayout>
        <div style={{paddingTop: "3em"}}>
          <div className={`${commonStyles.fCenter} ${commonStyles.fRow}`} style={{ gap: "10px" }}>
            <a onClick={() => this.fastLaneService.redirectInquiryOrConfirm()}>
              <img src={use_fast_lane}/>
            </a>
            <div className={`${commonStyles.fCenter} ${commonStyles.fColumn}`} style={{ gap: "10px" }}>
              <a onClick={() => this.loungeSecondService.redirectInquiryOrConfirm()}>
                <img src={use_lounge_second}/>
              </a>
              <a onClick={() => this.loungeService.redirectInquiryOrConfirm()}>
                <img src={use_lounge}/>
              </a>
            </div>
          </div>

          {loginUserStore.loginUserInfo.company && moment(loginUserStore.loginUserInfo.company!.expiration_dt).diff(moment(timeStore.time), 'days') <= 60
            && <><br/><Alert message={"有効期限が６０日以内となっています。"} type={"error"}/></>
          }

          <br/>

          <div className={`${commonStyles.fCenter}`} style={{marginTop: "1.5em", borderBottom: "1px solid white"}}>
            <p className={appStyles.h3White} style={{marginBottom: 0}}>お知らせ</p>
          </div>
          <div style={{overflowY: "auto", maxHeight: "10em", marginBottom: "3em"}}>
            {this.informationStore!.list!.map((value) => {
              return <div className={appStyles.textWhite}
                          style={{marginBottom: 0, borderBottom: "1px dashed white", padding: "0.5em"}}
                          key={value.id}>
                <span style={{marginRight: "5em"}}>{value.publish_dt}</span>
                <Link to={`/information_detail/${value.id}`}>{value.title}</Link>
              </div>
            })}
          </div>

          <div className={commonStyles.fCenter}>
            <Link to={"/my_page"}>
              <img src={mypage_banner}/>
            </Link>
          </div>
          <div className={commonStyles.fCenter} style={{marginBottom: "1.5em"}}>
            <a href={"https://www.kansai-airport.or.jp/kix-gbc/user/"}>
              <img src={how_to_use_banner}/>
            </a>
            <a href={"https://www.kansai-airport.or.jp/kix-gbc/service/memberID/#airlines"}>
              <img src={koukuu_service_banner}/>
            </a>
            <a href={"https://www.kansai-airport.or.jp/kix-gbc/service/"}>
              <img src={tokutenn_banner}/>
            </a>
          </div>
          <div className={commonStyles.fCenter} style={{marginBottom: "1.5em"}}>
            <Button onClick={() => safeRedirect("https://www.kansai-airport.or.jp/kix-gbc/faq/2.html")}
                    className={`${appStyles.buttonWhite} ${commonStyles.mr5}`} style={{color: "#00125E"}}>
              よくある質問
            </Button>
            <Button onClick={() => safeRedirect("https://www.kansai-airport.or.jp/kix-gbc/#contact")}
                    className={`${appStyles.buttonWhite}`} style={{color: "#00125E"}}>
              お問い合わせ
            </Button>
          </div>

        </div>

        {this.fastLaneService.displayModal()}
        {this.loungeService.displayModal()}
        {this.loungeSecondService.displayModal()}
      </KixGbcMemberLayout>
    );
  }
}

export default Form.create()(Member)
